import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import UrgentBookingsRealDataTable from '@/components/tables/UrgentBookingsRealDataTable';

interface UrgentBookingsPageProps {
    onNavigate: (view: string) => void;
  }
  
const UrgentBookingsPage: React.FC<UrgentBookingsPageProps> = ({ onNavigate }) => {
    const { currentUser } = useAuth();
    
    return (
        <div className="space-y-8 animate-in fade-in">
          <div className="flex justify-between items-center">
            <h1 className="text-3xl font-bold text-white mb-1">Urgent Bookings Management</h1>
            <button
              onClick={() => onNavigate('/dashboard')}
              className="bg-kala-secondary hover:bg-cyan-400 text-kala-900 font-bold py-2 px-4 rounded"
            >
              Back to Dashboard
            </button>
          </div>
          <div id="urgent-booking-tables" className="grid grid-cols-1 gap-8 mt-8">
            {currentUser ? (
              <UrgentBookingsRealDataTable currentUserRole={currentUser.role} currentUserId={currentUser.id} />
            ) : (
              // Handle the case where currentUser is not yet available
              <p>Loading user information...</p>
            )}
          </div>
        </div>
      );
    };
    
    export default UrgentBookingsPage;